/**
 * Created by Caroline on 2019/11/25 0025.
 *
 */
export function GetRequest() {
  let query = {};
  if(location.href.indexOf('?') < 0){
    return query;
  }
  let url = location.href.split("?")[1].split("&"); //获取url中"?"符后的字串
  // console.log(url);
  url.forEach(item => {
    query[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]);  //转码
  });
  return query;
}

Array.intersect = function(arr1, arr2) {
  if(Object.prototype.toString.call(arr1) === "[object Array]" && Object.prototype.toString.call(arr2) === "[object Array]") {
    return arr1.filter(function(v){
      return arr2.indexOf(v)!==-1
    })
  }
}

// 开启全屏
export function lanchFullscreen(e){
  if (e.requestFullscreen) {
    e.requestFullscreen();
  }
  if (e.mozRequestFullScreen) {
    e.mozRequestFullScreen();
  }
  if (e.msRequestFullscreen) {
    e.msRequestFullscreen();
  }
  if (e.webkitRequestFullscreen) {
    e.webkitRequestFullscreen();
  }
}

// 退出全屏
export function exitFullscreen(){
  if(document.exitFullscreen){
    document.exitFullscreen();
  }
  if(document.mozCancelFullScreen){
    document.mozCancelFullScreen();
  }
  if(document.msExitFullscreen){
    document.msExiFullscreen();
  }
  if(document.webkitCancelFullScreen){
    document.webkitCancelFullScreen();
  }
}

export function compare(v1, v2) {
  if(v1 < v2) {
    return -1
  }
  else if(v1 > v2) {
    return 1
  }
  else {
    return 0
  }
}



// WEBPACK FOOTER //
// ./src/lib/common.js